import { useQuery, useMutation, useQueryClient } from "react-query";
import { api } from "../config/api";

// ── Shape returned by GET /api/settings/reminders ────────────────────────────
export interface ReminderSettings {
  user_id: string; // UUID
  reminder_days: number[];
  email_enabled: boolean;
  send_hour: number; // 0-23 UTC
  timezone: string;
  from_name: string | null;
  reply_to: string | null;
  custom_subject: string | null;
  custom_body_html: string | null;
}

// ── Shape accepted by PUT /api/settings/reminders ────────────────────────────
export interface ReminderSettingsUpdate {
  reminder_days?: number[];
  email_enabled?: boolean;
  send_hour?: number;
  timezone?: string;
  from_name?: string | null;
  reply_to?: string | null;
  custom_subject?: string | null;
  custom_body_html?: string | null;
}

// ─────────────────────────────────────────────────────────────────────────────

export const useReminderSettings = () =>
  useQuery<ReminderSettings>(
    "reminderSettings",
    async () => {
      const { data } = await api.get("/settings/reminders");
      return data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 min
      retry: 1,
    }
  );

export const useUpdateReminderSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: ReminderSettingsUpdate) => {
      const { data } = await api.put("/settings/reminders", payload);
      return data as ReminderSettings;
    },
    {
      onSuccess: (updated) => {
        queryClient.setQueryData("reminderSettings", updated);
      },
    }
  );
};
